import { trackEvent } from '$app/analytics/helpers.js';

export class Ga4PurchaseComponent extends HTMLElement {
  connectedCallback(): void {
    const transactionId = this.getAttribute('transaction-id');
    const value = Number.parseFloat(this.getAttribute('value') ?? '');
    const donationFrequency = this.getAttribute('donation-frequency');

    if (!transactionId || !donationFrequency) {
      console.warn(
        'Ga4PurchaseComponent: Missing transaction-id or donation-frequency. Doing nothing.'
      );
      return;
    }

    trackEvent('purchase', {
      transaction_id: transactionId,
      value,
      currency: 'USD',
      items: [
        {
          item_name: 'Donation',
          item_variant: donationFrequency,
          price: value,
          quantity: 1,
        },
      ],
    });
  }
}

declare global {
  interface Window {
    Ga4PurchaseComponent: typeof Ga4PurchaseComponent;
  }
  interface HTMLElementTagNameMap {
    'tmp-ga4-purchase': Ga4PurchaseComponent;
  }
}

if (!window.customElements.get('tmp-ga4-purchase')) {
  window.Ga4PurchaseComponent = Ga4PurchaseComponent;
  window.customElements.define('tmp-ga4-purchase', Ga4PurchaseComponent);
}
